function setGrid(cols) {
  const grid = document.querySelector('#product-grid');
  if (!grid) return; 
  grid.classList.remove('grid--4', 'grid--6');
  grid.classList.add(`grid--${cols}`);

  const toggleBtn = document.querySelector('#gridToggleBtn');
  if (toggleBtn) {
    toggleBtn.classList.toggle('active-6', cols === '6');
  }

  sessionStorage.setItem('productGridCols', cols);
}

function toggleLayout(e) {
  e.preventDefault();
  const grid = document.querySelector('#product-grid');
  if (grid) {
    const isFour = grid.classList.contains('grid--4');
    setGrid(isFour ? '6' : '4');
  }
}


// 페이지 로드 시 저장된 값 적용
document.addEventListener('DOMContentLoaded', () => {
  const savedCols = sessionStorage.getItem('productGridCols') || '6';
  setGrid(savedCols);
  initSwipers()
  reinitInfiniteScroll()
});


function initSwipers() {
  document.querySelectorAll('.card-swiper:not([data-initialized])').forEach((el) => {
    new Swiper(el, {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
    });
    el.setAttribute('data-initialized', 'true');
  });

}

let infScroll = null;

function reinitInfiniteScroll() {
  const elem = document.querySelector('#product-grid');

  const nextLink = document.querySelector('.pagination__item.pagination__item--prev');

  const savedCols = sessionStorage.getItem('productGridCols') || '6';
  setGrid(savedCols);


  if (!elem || !nextLink) {
    const status = document.querySelector('.page-load-status');
    if (status) status.style.display = 'none';
    return;
  }

  if (infScroll) {
    infScroll.destroy();
    infScroll = null;
  }

  infScroll = new InfiniteScroll(elem, {
    path: '.pagination__item.pagination__item--prev', 
    append: 'li.grid__item',
    history: false,
    scrollThreshold: 400, 
    prefill: true,
    status: '.page-load-status',
    checkLastPage: true
  });

  infScroll.on('append', (response, path, items) => {
    initSwipers();
  });

  infScroll.loadNextPage();
}



const gridChangeFunc = () => {
  document.querySelector('.grid-change').classList.toggle('changed')
  document.querySelector('.fm-plp-grid').classList.toggle('change-grid')
}


const opendPlpSidebar = (className) => {
  document.body.classList.add(className, 'plp-sidebar-opened');

  document.body.classList.add('overflow-hidden');
};

const closePlpSidebar = (className) => {

  initSwipers()
  document.body.classList.remove(className, 'plp-sidebar-opened');
  document.body.classList.remove('overflow-hidden');
};


document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;
});

// PLP 스크롤 방향 감지
let lastScrollTop = 0;

function handlePlpScrollDirection() {
  const header = document.querySelector('.section-header');
  const body = document.body;


  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    // 스크롤 다운
    body.classList.remove('plp-user-scrolled-up');
    body.classList.add('plp-user-scrolled-down');
  } else {
    // 스크롤 업
    body.classList.remove('plp-user-scrolled-down');
    body.classList.add('plp-user-scrolled-up');
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

// 스크롤 이벤트 리스너 등록
window.addEventListener('scroll', handlePlpScrollDirection);
window.addEventListener('resize', handlePlpScrollDirection);
